export const TOUR_STEPS = {
  '/dashboard': [
    {
      target: '[data-tour="dashboard-stats"]',
      title: 'Today at a Glance',
      content: 'These cards show today\'s appointment count, completion status, and crew utilisation in real time.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="dashboard-date"]',
      title: 'Date Navigation',
      content: 'Click any date to jump to that day\'s schedule. The calendar and appointment list update instantly.',
    },
    {
      target: '[data-tour="dashboard-provider-filter"]',
      title: 'Crew Filter',
      content: 'Narrow the view to specific crew members. Useful when managing a large team across multiple services.',
    },
    {
      target: '[data-tour="dashboard-calendar"]',
      title: 'Schedule Calendar',
      content: 'View all appointments for the selected date. Colour coding shows booking status — hover over an event for details.',
    },
    {
      target: '[data-tour="dashboard-new-appointment"]',
      title: 'Create a New Appointment',
      content: 'Click here to open the appointment panel where you can select a service, assign a crew member, and pick a time slot.',
    },
  ],

  '/vendor_bookings': [
    {
      target: '[data-tour="booking-phone"]',
      title: 'Start with the Phone Number',
      content: 'Enter the customer\'s number first — the system will auto-fill their name, email, and address from previous bookings.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="booking-address"]',
      title: 'Service Address',
      content: 'Type to search via Google Maps. The area and state fields fill automatically once you confirm the address.',
    },
    {
      target: '[data-tour="booking-details"]',
      title: 'Booking Details',
      content: 'Select the profile (branch) for this booking. It determines crew assignment and invoicing. Status and payment are set in the last step.',
    },
    {
      target: '[data-tour="booking-services"]',
      title: 'Select Services',
      content: 'Choose all services for this visit. The total in the summary updates as you add or remove items.',
    },
    {
      target: '[data-tour="booking-crew"]',
      title: 'Crew & Time Slot',
      content: 'Pick the date, then click a free slot in the availability grid to assign the crew member and time.',
    },
    {
      target: '[data-tour="booking-pricing"]',
      title: 'Pricing Summary',
      content: 'Review the subtotal, discount (flat or %), tax, and final total, then choose how the customer pays. Tax is calculated automatically.',
    },
  ],

  '/analytics': [
    {
      target: '[data-tour="analytics-period"]',
      title: 'Select a Time Period',
      content: 'Choose Today, This Week, This Month, This Year, or a Custom Range. All metrics and charts update to match your selection.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="analytics-kpis"]',
      title: 'Key Performance Indicators',
      content: 'Top-line metrics for the selected period — total bookings, completion rate, revenue, and crew performance. Click the ℹ icon on any card for a detailed explanation.',
    },
    {
      target: '[data-tour="analytics-tabs"]',
      title: 'Detailed Analysis Tabs',
      content: 'Switch between Operations & Crew, Revenue & Growth, and Loss & Leakage for in-depth breakdowns of your business performance.',
    },
    {
      target: '[data-tour="analytics-export"]',
      title: 'Export Report',
      content: 'Download the current analytics view as a PDF or CSV to share with your team or include in stakeholder reports.',
    },
  ],

  '/providers': [
    {
      target: '[data-tour="providers-search"]',
      title: 'Search Crew',
      content: 'Type a name to filter the crew list instantly. Supports partial name matches.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="providers-filters"]',
      title: 'Filter by Service or Availability',
      content: 'Narrow results by service type, gender, or availability on a specific date. Combine filters to find exactly the right crew member.',
    },
    {
      target: '[data-tour="providers-card"]',
      title: 'Crew Profile Card',
      content: 'Click "View Profile" on any card to open the edit panel where you can update qualifications, contact details, and assigned services.',
    },
  ],

  '/subscription': [
    {
      target: '[data-tour="subscription-stats"]',
      title: 'Subscription Overview',
      content: 'Monitor active plans, upcoming expirations (next 15 days), and total plan count at a glance.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="subscription-table"]',
      title: 'Plan List',
      content: 'All your subscription plans with pricing, subscriber count, and status. Click a row to view details, edit, or deactivate a plan.',
    },
    {
      target: '[data-tour="subscription-create"]',
      title: 'Create a New Plan',
      content: 'Click here to define a new subscription plan — set the service, pricing, schedule type, and duration.',
    },
  ],
};
